export default "__VITE_ASSET__BUX1VkGw__"